module.exports = __webpack_public_path__ + "img/domain-d.c512355.svg";